var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLike(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/linear/like"
  }, /*#__PURE__*/React.createElement("g", {
    id: "like"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M4.05176 9.93983L5.73092 11.2398C5.94759 11.4565 6.43509 11.5648 6.76009 11.5648H8.81843C9.46843 11.5648 10.1726 11.0773 10.3351 10.4273L11.6351 6.47316C11.9059 5.71483 11.4184 5.06483 10.6059 5.06483H8.43926C8.11426 5.06483 7.84342 4.794 7.89759 4.41483L8.16842 2.6815C8.27676 2.194 7.95176 1.65233 7.46426 1.48983C7.03092 1.32733 6.48926 1.544 6.27259 1.869L4.05176 5.17316",
    stroke: "currentColor",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M1.28857 9.94028V4.63195C1.28857 3.87362 1.61357 3.60278 2.37191 3.60278H2.91357C3.67191 3.60278 3.99691 3.87362 3.99691 4.63195V9.94028C3.99691 10.6986 3.67191 10.9695 2.91357 10.9695H2.37191C1.61357 10.9695 1.28857 10.6986 1.28857 9.94028Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLike);
export default __webpack_public_path__ + "static/media/like.58e5144e78d07483a2b5078bee315727.svg";
export { ForwardRef as ReactComponent };